import * as t from './actionTypes';

export const fetchUserMappingsRequest = () => ({
  type: t.FETCH_USER_MAPPINGS_REQUEST,
});

export const fetchUserMappingsResponse = (userMappings /*: [] */) => ({
  type: t.FETCH_USER_MAPPINGS_RESPONSE,
  userMappings,
});

export const fetchUserMappingsError = (error) => ({
  type: t.FETCH_USER_MAPPINGS_ERROR,
  error,
});
